import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { Observable, of } from 'rxjs';

import { AuthService } from './auth.service';
import { CONSTANTS } from '../../config';
import { LocalService } from './local.service';
import { catchError, map } from 'rxjs/operators';
import { FooterService } from './footer.service';
import { CommonRouteService } from './common-route.service';

@Injectable()
export class AuthGuard implements CanActivate {
  constructor(private authService: AuthService, private router: Router) {}

  canActivate(): boolean {
    if (this.authService.isAuthenticated) {
      return true;
    }
    this.router.navigate(['/']);
    return false;
  }
}

@Injectable()
export class ManagerRole implements CanActivate {
  constructor(private authService: AuthService, private router: Router) {}

  canActivate(): boolean {
    if (this.authService.isAuthenticated) {
      const userData = LocalService.get('userProfile');
      const managerRoles = CONSTANTS.manager;
      const intersection = userData.roles.filter((element: { name: string }) =>
        managerRoles.includes(element.name)
      );
      if (intersection.length) {
        return true;
      }
      this.router.navigateByUrl('/');
      return false;
    }
    return false;
  }
}

@Injectable()
export class SellerRole implements CanActivate {
  constructor(private authService: AuthService, private router: Router) {}

  canActivate(): boolean {
    if (this.authService.isAuthenticated) {
      const userData = LocalService.get('userProfile');
      const sellerRoles = CONSTANTS.seller;
      const intersection = userData.roles.filter((element: { name: string }) =>
        sellerRoles.includes(element.name)
      );
      if (intersection.length) {
        return true;
      }
      this.router.navigateByUrl('/');
      return false;
    }
    return false;
  }
}

@Injectable()
export class MaintainanceGaurd implements CanActivate {
  constructor(
    private authService: AuthService,
    readonly footerService: FooterService,
    readonly router: Router
  ) {}
  canActivate(): Observable<boolean> {
    return this.footerService.getMaintenanceMessage().pipe(
      map((data) => {
        if (data && !data.underMaintenance) return true;
        else {
          this.authService.clearAll();
          this.router.navigateByUrl('/maintenance');
          return false;
        }
      }),
      catchError((error) => {
        console.error('Error fetching maintenance status:', error);
        return of(true);
      })
    );
  }
}

@Injectable()
export class CanAccessHomeModule implements CanActivate {
  constructor(
    private authService: AuthService,
    private router: Router,
    private commonRouteService: CommonRouteService
  ) {}

  canActivate(): boolean {
    let flag = false;
    if (this.authService.isAuthenticated) {
      const userData = LocalService.get('userProfile');
      flag = this.commonRouteService.navigateUser(userData, true);
    }
    return flag;
  }
}
